import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EcontentServicesService } from '../../../../inputfileds/form_services/econtent-services/econtent-services.service';
import { Inputfiledsbase } from '../../../../inputfileds/models/inputfiledsbase';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DynamicFormQuestionComponent } from '../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { MatCardModule } from '@angular/material/card';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-componentadd',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    DynamicFormQuestionComponent,
    MatCardModule,
    ReactiveFormsModule,
    TranslateDirective
  ],
  templateUrl: './componentadd.component.html',
  styleUrl: './componentadd.component.scss',
})
export class ComponentaddComponent implements OnInit {
  @Input() questions: Inputfiledsbase<string>[] | null = [];
  @Input() form!: FormGroup;
  @Output() submitForm = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();
  @Input() editdata: any = {};

  fileToUpload: File | null = null;
  filePreview: string | null = null;
  fileName: string | null = null;
  fromcontrols: any;
  selectedFileName = '';
  flag: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (Object.keys(this.editdata).length > 0) {
      this.flag = true;
      const data = {
        component_name: this.editdata.name,
        model_id: this.editdata.model_id,
      };
      this.fileName = this.editdata.image_url.split('/')[2];
      this.form.patchValue(data);
      this.form.controls['model_id'].disable();
    } else {
      this.flag = false;
      this.form?.enable();
      this.form?.reset();
    }
  }

  onSubmit() {
    // Mark all fields as touched to show validation errors
    Object.keys(this.form.controls).forEach((key) => {
      this.form.controls[key].markAsTouched();
    });

    if (!this.form.valid) {
      console.error('Form is invalid:', this.form.errors);
      console.log('Form values:', this.form.value);
      return;
    }

    const formData = new FormData();

    // Add component_name
    const componentName = this.form.value['component_name'];
    if (componentName) {
      formData.append('name', componentName);
    }

    // Add model_id
    if (Object.keys(this.editdata).length > 0) {
      formData.append('model_id', this.editdata.model_id);
    } else {
      const modelId = this.form.value['model_id'];
      if (modelId) {
        formData.append('model_id', modelId);
      }
    }

    // Add description
    formData.append('description', '');

    // Add image file
    if (this.fileToUpload) {
      formData.append('image', this.fileToUpload);
    }

    // Log FormData for debugging
    console.log('FormData being submitted:');
    formData.forEach((value, key) => {
      console.log(key, value);
    });

    this.submitForm.emit(formData);
  }

  onFileSelected(event: Event) {
    this.fileToUpload = null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileToUpload = input.files[0];
      if (this.fileToUpload) {
        this.fileName = this.fileToUpload.name;
        const reader = new FileReader();
        reader.onload = () => {
          this.filePreview = reader.result as string;
        };
        reader.readAsDataURL(this.fileToUpload);
      } else {
        this.filePreview = null;
      }
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}
